var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2336 9.00004L18.05 1.24599C18.3251 0.972988 18.3251 0.530374 18.05 0.257411C17.7748 -0.0155528 17.3286 -0.0155878 17.0534 0.257411L9.23704 8.01147L1.42069 0.257411C1.1455 -0.0155878 0.699326 -0.0155878 0.424168 0.257411C0.14901 0.530409 0.148975 0.973023 0.424168 1.24599L8.24052 9.00001L0.424168 16.7541C0.148975 17.0271 0.148975 17.4697 0.424168 17.7426C0.561747 17.8791 0.742097 17.9473 0.922447 17.9473C1.1028 17.9473 1.28311 17.8791 1.42073 17.7426L9.23704 9.98862L17.0534 17.7426C17.191 17.8791 17.3713 17.9473 17.5517 17.9473C17.732 17.9473 17.9123 17.8791 18.05 17.7426C18.3251 17.4696 18.3251 17.027 18.05 16.7541L10.2336 9.00004Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrayIcon);
export default __webpack_public_path__ + "static/media/closeGrayIcon.80edd9811ee1b7098ea9f9095c79c02a.svg";
export { ForwardRef as ReactComponent };